import Api from 'portal-modules/common/api'
import { call, put, takeLatest } from 'redux-saga/effects'
import { LOGOUT } from 'portal-modules/auth/redux/modules/user'
import createRequestSaga from '../create-request-saga'

// action types
export const REQUEST_PRIVACY_POLICIES =
  'rp/contact_property/REQUEST_PRIVACY_POLICIES'
export const RECEIVE_PRIVACY_POLICIES =
  'rp/contact_property/RECEIVE_PRIVACY_POLICIES'

// action creators
export const requestPrivacyPolicies = (property_id = null, cid = null) => ({
  type: REQUEST_PRIVACY_POLICIES,
  property_id,
  cid,
})

export const receivePrivacyPolicies = payload => ({
  type: RECEIVE_PRIVACY_POLICIES,
  payload,
})

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_PRIVACY_POLICIES:
      return { ...state, ...payload }
    case LOGOUT:
      return {}
    default:
      return state
  }
}

function* fetchPrivacyPolicies({ property_id, cid }) {
  const {
    show_privacy_requests,
    primary_privacy_policy,
    secondary_privacy_policy,
    show_entrata_privacy_policy,
  } = yield call(Api.getPrivacyPolicies, { property_id, cid })

  const privacyPolicies = {
    show_privacy_requests,
    primary_privacy_policy,
    secondary_privacy_policy,
    show_entrata_privacy_policy,
  }

  yield put(receivePrivacyPolicies(privacyPolicies))
}

export function* watchRequestPrivacyPolicies() {
  yield takeLatest(
    REQUEST_PRIVACY_POLICIES,
    createRequestSaga(fetchPrivacyPolicies, {
      key: 'privacyPolicies',
      message: __('Fetching Privacy Policies'),
    }),
  )
}

export const sagas = [watchRequestPrivacyPolicies]
